const MuiDialogContent = {
    styleOverrides: {
        root: {
            padding: '0rem 1.5rem 1rem 1.5rem'
        },
    }
};

export default MuiDialogContent;